<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>经销商账户</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row>
        <el-col :span="8">
          <el-input placeholder="请输入经销商名称" v-model="queryInfo.query" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="getOrderList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="block">
            <el-date-picker
              v-model="queryInfo.time"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
            <el-button slot="append" icon="el-icon-search" @click="getOrderList"></el-button>
          </div>
          
        </el-col>
        <el-col :span="8" v-if="canLook == 1">
          <a class="aaaa" :href="exportUrl">
            <el-button size="mini" type="info">导出表格</el-button>
          </a>
        </el-col>
      </el-row>

      <!-- 订单列表数据 -->
      <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index"></el-table-column>
        <!-- <el-table-column label="订单编号" prop="order_id" width="150px"></el-table-column> -->
        <el-table-column label="经销商" prop="agencyName" width="130px"></el-table-column>
        <el-table-column label="充值总额">
           <template slot-scope="scope">
            <div v-if="queryInfo.time">无</div>
            <div v-else>{{scope.row.allChargeMoney}}</div>
           </template>
        </el-table-column>
        <el-table-column label="充值余额" prop="money"></el-table-column>
        <el-table-column label="授信余额" prop="creditMoney"></el-table-column>
        <el-table-column label="返点" prop="refund"></el-table-column>
        <el-table-column label="设备补贴" prop="subsidy"></el-table-column>
        <el-table-column label="冻结余额" prop="blockingMoney"></el-table-column>
        <el-table-column label="最近一次充值" >
          <template slot-scope="scope">
            <div v-if="queryInfo.time">无</div>
            <div v-else>{{scope.row.moreNewRechargeLog}}</div>
          </template>
        </el-table-column>
        <el-table-column label="累计总消费">
          <template slot-scope="scope">
            <div v-if="queryInfo.time">无</div>
            <div v-else>{{scope.row.allMonthLog}}</div>
          </template>
        </el-table-column>
        <el-table-column label="上月累计消费">
          <template slot-scope="scope">
            <div v-if="queryInfo.time">无</div>
            <div v-else>{{scope.row.lastmonthLog}}</div>
          </template>
        </el-table-column>
        <el-table-column label="本月累计消费">
          <template slot-scope="scope">
            <div v-if="queryInfo.time">无</div>
            <div v-else>{{scope.row.monthLog}}</div>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="160px">
          <template slot-scope="scope">
            <!-- <el-button size="mini" type="primary" @click="editOrder(scope.row.order_id)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteOrder(scope.row.order_id)">删除</el-button>
            <a class="aaaa" target="_blank" :href="scope.row.export" v-if="scope.row.order_status == 2">
              <el-button size="mini" @click="exportOrder()" type="info">导出出货单</el-button>
            </a> -->
            <el-tooltip effect="dark" content="账户冲正" placement="top" :enterable="false">
              <el-button type="warning" icon="el-icon-setting" size="mini" @click="addMoneyToRole(scope.row)"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 修改地址的对话框 -->
    <el-dialog title="修改经销商金额" :visible.sync="addMoneyDialogVisible" width="50%" @close="addMoneyDialogVisibleClosed">
      <el-form :model="czForm" :rules="czFormRules" ref="czFormRef" label-width="100px">
        <el-form-item label="现有账户余额" prop="money">
          <el-input v-model="czForm.money" disabled></el-input>
        </el-form-item>

        <el-form-item label="增加/减少">
          <el-radio v-model="czForm.addtip" label="add">增加</el-radio>
          <el-radio v-model="czForm.addtip" label="reduce">减少</el-radio>
        </el-form-item>

        <el-form-item label="修改金额数" prop="changemoney">
          <el-input v-model="czForm.changemoney"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addMoneyDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureChangeMoney">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data () {
    return {
      canLook: 1,
      exportUrl: 'https://hsapi.hsxsn.cn//jxsAccountList?mPhone=' + localStorage.getItem('phone'),
      queryInfo: {
        query: '',
        status: -1,
        type: 0,
        pagenum: 1,
        pagesize: 10
      },
      statusValue: '全部',
      // 审核状态0未审核，1审核通过2拒绝
      statusOptions: [
        { value: '全部', id: -1 },
        { value: '未审核', id: 0 },
        { value: '审核通过', id: 1 },
        { value: '拒绝', id: 2 },
      ],
      typeValue: '全部',
      typeOptions: [
        { value: '全部', id: 0 },
        { value: '常温', id: 1 },
        { value: '低温', id: 2 },
      ],
      total: 0,
      orderlist: [],
      progressVisible: false,
      progressInfo: [],
      multipleSelection: [],
      multipleSelectionjson: null,

      czForm: {
        id: null,
        money: null,
        changemoney: null,
        addtip: 'add',
      },

      addMoneyDialogVisible: false,
      czFormRules: {
        changemoney: [
          { required: true, message: '请输入要修改的金额', trigger: 'blur' }
        ]
      },
    }
  },

  created () {
    this.getOrderList()
  },

  methods: {
    addMoneyDialogVisibleClosed () {
      this.addMoneyDialogVisible = false
    },
    //账户冲正
    addMoneyToRole (row) {
      this.selectPhone = row.phone;
      this.czForm.money = row.money;
      this.addMoneyDialogVisible = true
    },

    //修改经销商账户
    async sureChangeMoney () {
      this.$refs.czFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('admin/user/changeMoney', {
          money: this.czForm.changemoney,
          addtip: this.czForm.addtip,
          phone: this.selectPhone
        })
        if (res.code !== 200) {
          return this.$message.error(res.message)
        }
        this.$message.success('设置成功！')
        this.getOrderList();
        this.addMoneyDialogVisible = false;
      })
    },

    // 编辑
    editOrder (id) {
      console.log(id);
      this.$router.push({ path: '/orders/detail', query: { id: id } })
    },

    // 删除
    async deleteOrder (id) {
      const confirmResult = await this.$confirm(
        '订单删除后将不可找回,是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/delete', {
        id: id,
      })
      if (res.code !== 200) {
        return this.$message.error('删除订单失败！')
      }
      this.$message.success('删除订单成功！')
      this.getOrderList()
    },


    filterSelect () {
      this.total = 0
      this.orderlist = []
      this.getOrderList()
    },

    // 多选选择的项
    handleSelectionChange (val) {

      this.multipleSelection = val;
      var list = [];
      val.forEach(element => {
        list.push({ 'id': element.id });
      });
      if (list.length > 0) {
        this.multipleSelectionjson = JSON.stringify(list);
        this.exportUrl = 'https://hsapi.hsxsn.cn//jxsAccountList?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
        // console.log(this.exportUrl);
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = 'https://hsapi.hsxsn.cn//jxsAccountList?mPhone=' + localStorage.getItem('phone')
      }
    },

    async getOrderList () {
      console.log(this.queryInfo)
      const { data: res } = await this.$http.post('admin/users/getjxsComsumeList', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('获取列表失败！')
      }
      console.log(res)
      this.total = res.result.count
      this.orderlist = res.result.list
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },

    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },

  }
}
</script>

<style lang="less" scoped>
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 30px;
}

.daiqueren {
  background-color: aquamarine;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}
.yifahuo {
  background-color: rgb(8, 27, 133);
}

.aaaa {
  margin-left: 10px;
}
</style>
